"use strict";

var _classCallCheck = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var resolve_1 = require("./resolve");

var MissingRefError = /*#__PURE__*/function (_Error) {
  _inherits(MissingRefError, _Error);

  var _super = _createSuper(MissingRefError);

  function MissingRefError(baseId, ref, msg) {
    var _this;

    _classCallCheck(this, MissingRefError);

    _this = _super.call(this, msg || "can't resolve reference ".concat(ref, " from id ").concat(baseId));
    _this.missingRef = resolve_1.resolveUrl(baseId, ref);
    _this.missingSchema = resolve_1.normalizeId(resolve_1.getFullPath(_this.missingRef));
    return _this;
  }

  return MissingRefError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.default = MissingRefError;